import BasicResources from './basic-resources';

class Resources {
  static createResources(parentEnv) {
    const env = parentEnv || Resources.env;
    const BASE_URL_UPF_ASSIGN = '@UpfAssignGateway';

    /* Config */
    Resources.getConfigurationItem = async key => env.getConfigurationItem(key);

    /* Filters */
    Resources.genericCourses = env
      .resource('genericcourse')
      .baseUrl(BASE_URL_UPF_ASSIGN)
      .service('courses/genericcourse/{courseId}');

    Resources.studentassignments = env
      .resource('studentassignments')
      .baseUrl(BASE_URL_UPF_ASSIGN)
      .service('getStudentsAssignments');

    Resources.assignmentsByStudent = env
      .resource('getStudentAssignments')
      .baseUrl(BASE_URL_UPF_ASSIGN)
      .service('getStudentAssignments');

    Resources.assign = env.resource('assign').baseUrl(BASE_URL_UPF_ASSIGN).service('assign');

    Resources.unassign = env.resource('unassign').baseUrl(BASE_URL_UPF_ASSIGN).service('unassign');

    Resources.restrictActivities = Resources.env
      .resource('restrictActivities')
      .baseUrl(BASE_URL_UPF_ASSIGN)
      .service('restrict/{isRestricted}/classroom/{classId}/group/{groupId}');

    Resources.previewAssignment = env
      .resource('previewAssignment')
      .baseUrl(BASE_URL_UPF_ASSIGN)
      .service('assign/preview');

    Resources.assignments = env
      .resource('assignments')
      .baseUrl(BASE_URL_UPF_ASSIGN)
      .service(
        'assignment-management/products/{productId}/classes/{classId}/courses/{courseId}/versions/{version}/assignments'
      );

    Resources.studentAssignmentsHistory = env
      .resource('studentAssignmentsHistory')
      .baseUrl(BASE_URL_UPF_ASSIGN)
      .service(
        // eslint-disable-next-line max-len
        `assignment-management/products/{productId}/classes/{classId}/students/{studentUserProfileId}/courses/{courseId}/versions/{courseVersion}/learning-journeys/{learningJourneyId}/assignments`
      );

    Resources.getAssignmentInitData = env
      .resource('getAssignmentInitData')
      .baseUrl(BASE_URL_UPF_ASSIGN)
      .service('assignment-management/products/{productId}/data');
  }
  static initialise(envName, credentials) {
    Resources.env = BasicResources.initialise(envName, credentials);

    Resources.createResources();

    return Resources.env;
  }
}

export default Resources;



// WEBPACK FOOTER //
// ./helpers/resources.js